import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import Hidden from '@glass/web/components/base/Hidden';
import { ALL_BREAKPOINTS } from '@glass/web/modules/theme/breakpointKeys';
import makeStyles from '@glass/web/modules/theme/makeStyles';

import ResourceCard from '@glass/shared/components/Content/ResourceCard';
import calcImageSizesV2 from '@glass/shared/components/Image/calcImageSizesV2';

export const breakpoints = {
  xs: 12,
  sm: 6,
  md: 4,
  lg: 3,
};

const imageSizes = calcImageSizesV2({ breakpoints });

const useStyles = makeStyles()({
  fullHeight: {
    height: '100%',
  },
});

const useHiddenOnly = ({ idx, minNum, numRows, maxNum }) => {
  return useMemo(() => {
    const only = ALL_BREAKPOINTS.filter((breakpoint) => {
      return (
        Math.min(maxNum, Math.max(((numRows || 1) * 12) / breakpoints[breakpoint], minNum, 1)) <
        idx + 1
      );
    });

    return { only: only.length > 0 ? only : undefined };
  }, [maxNum, numRows, idx, minNum]);
};

function ResourceCardHiddenContainer({
  idx,
  blogPost,
  disableTags,
  variant,
  loading,
  numRows,
  minNum,
  maxNum,
  onTagClick,
  onClick,
}) {
  const { classes } = useStyles();
  const { only } = useHiddenOnly({ idx, minNum, maxNum, numRows });

  return (
    <Hidden className={classes.fullHeight} implementation="css" only={only}>
      <ResourceCard
        blogPost={blogPost}
        disableTags={disableTags}
        imageSizes={imageSizes}
        loading={loading}
        titleVariant="h5"
        variant={variant}
        onClick={onClick}
        onTagClick={onTagClick}
      />
    </Hidden>
  );
}

ResourceCardHiddenContainer.defaultProps = {
  numRows: 2,
  minNum: 4,
  maxNum: 8,
};

ResourceCardHiddenContainer.propTypes = {
  blogPost: PropTypes.shape({
    slug: PropTypes.string.isRequired,
  }).isRequired,
  disableTags: PropTypes.bool,
  idx: PropTypes.number,
  loading: PropTypes.bool,
  maxNum: PropTypes.number,
  minNum: PropTypes.number,
  numRows: PropTypes.number,
  onClick: PropTypes.func,
  onTagClick: PropTypes.func,
  variant: PropTypes.string,
};

ResourceCardHiddenContainer.displayName = 'ResourceCardHiddenContainer';

export default ResourceCardHiddenContainer;
